import React from "react";
import {Business, CurrentUser, UserType} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import MenuList from "../../components/menu/MenuList";
import {useNavigate} from "react-router";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
}

function MenuPage(props: Props) {
  const navigate = useNavigate();

  return (
      <>
        <AuthCheck />

        {props.currentUser.userType == UserType.LOCATION_MANAGER && <div>
            <div className={"primary-button pe-2 mb-2"} onClick={() => navigate("/menu/create-section")}>
                Create Menu Section
                <div className={"d-inline-block ms-2"}>
                    <FontAwesomeIcon icon={faPlus}/>
                </div>
            </div>
        </div>}

        {props.currentUser.business && <MenuList
            currentUser={props.currentUser}
            businessMap={props.businessMap}
            businessId={props.currentUser.business}
            displayConfigButtons={true}
        />}
      </>
  );
}

export default MenuPage;
